import { render } from "./index.vue?vue&type=template&id=3d90df62"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/design/components/atoms/list-group-header/index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3d90df62"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3d90df62', __exports__)) {
    api.reload('3d90df62', __exports__)
  }
  
  module.hot.accept("./index.vue?vue&type=template&id=3d90df62", () => {
    api.rerender('3d90df62', render)
  })

}


export default __exports__